import _ from 'lodash';
import { Form } from 'react-bootstrap';
import { Controller, FieldError, useFormContext } from 'react-hook-form';

import useResources from 'hooks/useResources';

export type HookSelectFormControlItem = {
    value: any; // TODO: Specify allowed types
    title: string;
};

interface HookSelectFormControlProps {
    name: string;
    label?: string;
    defaultValue?: any;
    rules?: any;
    type?: any;
    items: HookSelectFormControlItem[];
    addEmptyItem?: boolean;
    emptyItemTitle?: string;
    [key: string]: any;
}

const HookSelectFormControl = (props: HookSelectFormControlProps) => {
    const { name, label, defaultValue, rules, type, items, addEmptyItem, emptyItemTitle, ...rest } = props;
    const form = useFormContext();

    const { t } = useResources();

    // if (addEmptyItem) {
    //     items.unshift({ value: '', title: emptyItemTitle || t('ui.selectPlaceHolder.default') });
    // }

    return (
        <>
            {label && (
                <Form.Label>
                    {label}
                    {rules?.required && <span className="required-mark" />}
                </Form.Label>
            )}
            <Controller
                name={name}
                render={({ field }) => (
                    <Form.Control
                        // TODO: Add dropdown arrow
                        as="select"
                        {...field}
                        {...rest}
                        value={form.getValues(name) ?? ``}
                        isInvalid={!!_.get(form.formState.errors, name)}
                        onChange={(value) => {
                            field.onChange(value);
                            if (props.onChange) {
                                props.onChange(value);
                            }
                        }}
                    >
                        {items &&
                            [{ value: '', title: emptyItemTitle || t('ui.selectPlaceHolder.default') }, ...items]
                                .filter(
                                    (i, j) =>
                                        (j === 0 &&
                                            (i.title === emptyItemTitle ||
                                                i.title === t('ui.selectPlaceHolder.default')) &&
                                            !!addEmptyItem) ||
                                        j > 0,
                                )
                                .map((i: HookSelectFormControlItem) => (
                                    <option key={i.value} value={i.value}>
                                        {i.title}
                                    </option>
                                ))}
                    </Form.Control>
                )}
                control={form.control}
                defaultValue={defaultValue ?? ''}
                rules={rules}
            />
            <Form.Control.Feedback type="invalid">
                {(_.get(form.formState.errors, name) as FieldError)?.message}
            </Form.Control.Feedback>
        </>
    );
};

export default HookSelectFormControl;
